import { render, staticRenderFns } from "./editBillstatus.vue?vue&type=template&id=1024487e&scoped=true&"
import script from "./editBillstatus.vue?vue&type=script&lang=js&"
export * from "./editBillstatus.vue?vue&type=script&lang=js&"
import style0 from "./editBillstatus.vue?vue&type=style&index=0&id=1024487e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1024487e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1024487e')) {
      api.createRecord('1024487e', component.options)
    } else {
      api.reload('1024487e', component.options)
    }
    module.hot.accept("./editBillstatus.vue?vue&type=template&id=1024487e&scoped=true&", function () {
      api.rerender('1024487e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/editBillstatus.vue"
export default component.exports